export enum ClubTypeAbbreviation {
"Driver" = "Dr",
"2Wood" = "2W",
"3Wood" = "3W",
"4Wood" = "4W",
"5Wood" = "5W",
"6Wood" = "6W",
"7Wood" = "7W",
"8Wood" = "8W",
"9Wood" = "9W",
"1Hybrid" = "1H",
"2Hybrid" = "2H",
"3Hybrid" = "3H",
"4Hybrid" = "4H",
"5Hybrid" = "5H",
"6Hybrid" = "6H",
"7Hybrid" = "7H",
"8Hybrid" = "8H",
"9Hybrid" = "9H",
"1Iron" = "1i",
"2Iron" = "2i",
"3Iron" = "3i",
"4Iron" = "4i",
"5Iron" = "5i",
"6Iron" = "6i",
"7Iron" = "7i",
"8Iron" = "8i",
"9Iron" = "9i",
"PitchingWedge" = "PW",
"SandWedge" = "SW",
"LobWedge" = "LW",
"50Wedge" = "50W",
"52Wedge" = "52W",
"54Wedge" = "54W",
"56Wedge" = "56W",
"60Wedge" = "60W",
 "Putter" = "Pu",
 "NotDefined" =  ""
}

export interface IStringDictionary {
    [index: string]: string;    
}

export const ClubTypeAbbreviationDictionary : IStringDictionary  = {
    "Driver" : "Dr",
    "2Wood" : "2W",
    "3Wood" : "3W",
    "4Wood" : "4W",
    "5Wood" : "5W",
    "6Wood" : "6W",
    "7Wood" : "7W",
    "8Wood" : "8W",
    "9Wood" : "9W",
    "1Hybrid" : "1H",
    "2Hybrid" : "2H",
    "3Hybrid" : "3H",
    "4Hybrid" : "4H",
    "5Hybrid" : "5H",
    "6Hybrid" : "6H",
    "7Hybrid" : "7H",
    "8Hybrid" : "8H",
    "9Hybrid" : "9H",
    "1Iron" : "1i",
    "2Iron" : "2i",
    "3Iron" : "3i",
    "4Iron" : "4i",
    "5Iron" : "5i",
    "6Iron" : "6i",
    "7Iron" : "7i",
    "8Iron" : "8i",
    "9Iron" : "9i",
    "PitchingWedge" : "PW",
    "SandWedge" : "SW",
    "LobWedge" : "LW",
    "50Wedge" : "50W",
    "52Wedge" : "52W",
    "54Wedge" : "54W",
    "56Wedge" : "56W",
    "60Wedge" : "60W",
    "Putter" : "Pu",
    "NotDefined" :  "",
    "" : ""
};
